import React, { useMemo, useState } from 'react';
import WheelPicker from '../wheelPicker/WheelPicker';

let [hours, minutes] = [[], []];

for (let i = 0; i <= 59; i++) {
    if (i < 24){
        if(i < 10) hours.push(`0${i}`);
        else hours.push(`${i}`);
    } 
    if(i < 10) minutes.push(`0${i}`);
    else minutes.push(`${i}`);
}

export const TimePicker = ({col = 6 ,value ,onChange ,label ,required}) => {
  const [showPicker, setShowPicker] = useState(false);
  const [time, setTime] = useState({
    hour: "00",
    minute: "00",
  });
  const dataProps = useMemo(() => JSON.stringify({value, required, label}), [label, required, value]);
  function submitTime() {
    onChange(`${time.hour}:${time.minute}`);
    setShowPicker(false);
}

    function changeDate(name, value) {
        setTime(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }

  return (
    <>
        {showPicker && 
            <div className='date-picker'>
                <div className='picker-box'>
                <div className='d-flex justify-center'>
                            <div className='wheel-box ml20 mr20'>
                                <p className='text-center mb10'>ساعت</p>
                                <WheelPicker
                                    value={time.hour}
                                    onChange={(value) => changeDate('hour', value)}
                                >
                                    {
                                        hours.map(hour => (
                                            <div className='wheel-item' content={hour} key={hour}>{hour}</div>
                                        ))
                                    }
                                </WheelPicker>
                            </div>
                            <div className='wheel-box mr20 ml20'>
                                <p className='text-center mb10'>دقیقه</p>
                                <WheelPicker
                                    value={time.minute}
                                    onChange={(value) => changeDate('minute', value)}
                                >
                                    {
                                        minutes.map(minute => (
                                            <div className='wheel-item' content={minute} key={minute}>{minute}</div>
                                        ))
                                    }
                                </WheelPicker>
                            </div>
                        </div>
                <button
                    onClick={submitTime}
                    className='btn btn-green btn-block btn-circle mt10'
                >
                    تایید
                </button>
                </div>
            </div>
        }
      <div className={`col-${col}`} data-props={dataProps}>
        {label && (
          <div className="mt10 mb5">
            {required && <span className='required-icon'>* </span>}
            <label>{label}</label>
          </div>
        )}
        <div className="input-parent rtl">
          <button className="picker" onClick={() => setShowPicker(true)}>
            {value || "-- : --"}
          </button>
        </div>
      </div>
    </>
  );
}
